<template>
  <div v-html="infoText" v-if="serviceNotAvailable" class="not-available-wrapper">
  </div>
</template>

<style>
  .not-available-wrapper {
    margin-top: 48px;
  }
  .not-available-wrapper > p {
    margin: 24px 0;
  }
  .not-available-wrapper a {
    color: #40b8b8;
  }
</style>

<script>
import { mapState } from 'vuex';

export default {
  name: 'not-available-info',
  computed: {
    ...mapState({
      pos: (state) => state.pos.pos,
      onlineIssuing: (state) => state.pos.onlineIssuing,
    }),
    infoText() {
      return this.$t('notAvailable.info');
    },
    serviceNotAvailable() {
      return this.pos === null && this.onlineIssuing === null;
    },
  },
};
</script>
